export const SESSION_SERVICE_TIMEOUT_MS = 3_000;
